import React from "react";
import { KpiCard } from "./UI";
import { DoughnutChart } from "../charts/SimpleCharts";
import { fmtNum, fmtPct } from "../../utils/format";
import styles from "../../pages/pages.module.css";

// detail: [{site,title,visits,users,pageviews,bounce_rate,by_source[],by_device[],search_phrases[]}]
export default function MetrikaDetail({ detail }) {
  if (!detail || detail.length === 0) {
    return <div style={{ color: "var(--text-mute)", padding: 16 }}>Нет данных Яндекс.Метрики за этот период.</div>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {detail.map((s) => (
        <div key={s.site}>
          <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 12 }}>{s.title}</div>

          <div className={styles.kpiGrid} style={{ marginBottom: 16 }}>
            <KpiCard label="Визиты" value={fmtNum(s.visits)} />
            <KpiCard label="Пользователи" value={fmtNum(s.users)} />
            <KpiCard label="Просмотры" value={fmtNum(s.pageviews)} />
            <KpiCard label="Отказы" value={fmtPct(s.bounce_rate)} />
            <KpiCard
              label="Глубина"
              value={s.visits ? (s.pageviews / s.visits).toFixed(1) : "—"}
              sub="стр./визит"
            />
          </div>

          <div className={styles.grid2}>
            {s.by_source?.length > 0 && (
              <div>
                <div style={{ color: "var(--text-dim)", fontSize: 12.5, marginBottom: 8 }}>Источники трафика</div>
                <DoughnutChart labels={s.by_source.map((x) => x[0])} values={s.by_source.map((x) => x[1])} />
              </div>
            )}
            {s.by_device?.length > 0 && (
              <div>
                <div style={{ color: "var(--text-dim)", fontSize: 12.5, marginBottom: 8 }}>Устройства</div>
                <DoughnutChart labels={s.by_device.map((x) => x[0])} values={s.by_device.map((x) => x[1])} />
              </div>
            )}
          </div>

          {s.search_phrases?.length > 0 && (
            <div style={{ marginTop: 16 }}>
              <div style={{ color: "var(--text-dim)", fontSize: 12.5, marginBottom: 8 }}>Поисковые запросы (топ)</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {s.search_phrases.map((q, i) => (
                  <span
                    key={i}
                    style={{
                      background: "var(--bg)", border: "1px solid var(--border)",
                      borderRadius: 20, padding: "4px 12px", fontSize: 12.5,
                    }}
                    title={`${q.visits} визитов`}
                  >
                    {q.phrase} <b style={{ color: "var(--accent)" }}>{fmtNum(q.visits)}</b>
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
